class TileSheet {
  firstZoomCanvas: HTMLCanvasElement;

  scale: number;

  constructor(firstZoomCanvas: HTMLCanvasElement, scale: number) {
    this.firstZoomCanvas = firstZoomCanvas;
    this.scale = scale;
  }
}

export default TileSheet;
